


import '../SCSS/App.scss';
import Navigation from '../component/nav-bar';

const Track = () => {
    return (
       

      <div className="p-5">
    
                       <h1>I am a More page</h1>

                       <h1>This page are not available </h1>

      </div>
       
   )
 }


export default Track;